import { forwardRef } from 'react';
import { cn } from '@zep/utils';
import { OTPInput, OTPInputProps, OTPMethods } from './OtpInput';
type EmailVerifyCodeInputProps = Pick<OTPInputProps, 'value' | 'onChange'> & {
  disabled?: boolean;
  className?: string;
};
export const EmailVerifyCodeInput = forwardRef<OTPMethods, EmailVerifyCodeInputProps>((props: EmailVerifyCodeInputProps, ref) => {
  const {
    value,
    className: containerClassName,
    onChange,
    disabled
  } = props;
  return <OTPInput ref={ref} shouldAutoFocus={true} numInputs={6} inputType="tel" containerStyle={cn('gap-[8px] w-full items-center justify-center', containerClassName)} skipDefaultStyles={true} value={value} onChange={onChange} renderInput={({
    className,
    inputMode: _,
    ...rest
  }) => <input pattern="[0-9]+" inputMode="tel" minLength={1} maxLength={1} required disabled={disabled} className={cn('w-full flex-1 h-[48px] outline-none border-none rounded-[8px]', 'appearance-none', 'md:h-[56px]', 'text-h3 text-center text-primary', 'valid:bg-primaryBg', 'invalid:bg-gray-100', 'focus:ring-[1px] focus:ring-primary focus:bg-white', className)} {...rest} />} />;
});